export enum CustomizerOption {
  CUSTOMIZE_FOR_ME = "Open AI Pitch Writer",
  GET_BRAND_INFO = "Brand Info",
}
